import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory, withRouter } from 'react-router'

export default function(ComposedComponent) {
  class Authentication extends Component {
    componentDidMount = () => {
      if (this.props.authenticated) {
        browserHistory.push(this.nextPath(this.props))
      }
    }

    componentWillUpdate = nextProps => {
      if (nextProps.authenticated) {
        browserHistory.push(this.nextPath(nextProps))
      }
    }

    nextPath = ({location, userType}) => {
      const isManager = userType === 'MANAGER'

      const nextPath =
        location.query && location.query.next
          ? location.query.next
          : isManager? '/dashboard' : '/dashboard'

      return nextPath
    }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  function mapStateToProps(state) {
    return {
      authenticated: state.auth.authenticated,
      userType: state.auth.userType,
    }
  }

  return connect(mapStateToProps)(withRouter(Authentication))
}



// WEBPACK FOOTER //
// ./src/components/HOCs/RedirectIfAuthenticated.js